// Module
var code = "<div class=\"card mb-3\">\r\n\t<div class=\"card-header px-3 py-1\">\r\n\t\t<h5 class=\"m-0\">Tag Interni</h5>\r\n\t</div>\r\n\t<div class=\"card-body p-0\">\r\n\t\t<input id=\"tagsComponentTagsField\" class=\"border-0 form-control\" data-sh-prop=\"__tags\" data-sh-trigger=\"change\">\r\n\t</div>\r\n</div>\r\n";
// Exports
export default code;